import { TaskDetailPage } from './pages/TaskDetail.page'
import { TaskRootPage } from './pages/TaskRoot.page'

import type { RouteObject } from 'react-router-dom'

const taskRoutes: RouteObject[] = [
  {
    path: 'task',
    element: <TaskRootPage />,
    children: [
      {
        path: ':id',
        element: <TaskDetailPage />,
      },
    ],
  },
]

export { taskRoutes }
